import { parseYouTubeUrl } from './video';
import { encodeForURI } from './random';

const convertToStandard = ( original={} ) => {
    let output = { ...original };
    if( original.listid ) {
        //it's a list
        Object.assign( output, {
            id: output.listid,
            author: output.author || {},
            desires: ( output.desires || [] ).sort( ( a, b ) => {
                return a.sortorder - b.sortorder;
            } ),
            categories: output.categories || [],
            title: output.title,
            internal_link: `/${ output.author.slug }/${ output.slug }`,
            type: 'list',
            video_id: output.youtube,
            cover_image: output.coverImage,
            text: output.description,
        } );
    } else {
        Object.assign( output, {
            author: output.author || {},
            desires: ( output.desires || [] ).sort( ( a, b ) => {
                if( !a.curated_articles_desires ) {
                    return 0;
                }
                return a.curated_articles_desires.desire_order - b.curated_articles_desires.desire_order;
            } ),
            categories: output.categories || [],
            title: output.title,
            internal_link: `/app/articles/${ output.id }/${ encodeForURI( output.title ) }`,
            type: 'article',
            video_id: parseYouTubeUrl( output.video_url ),
            cover_image: output.cover_image,
            text: output.primary_text,
        } );
    }
    return output;
};

export {
    convertToStandard,
};
